import React__default, { createContext, useState, useEffect, useContext } from 'react';
import { getResponsiveSizePX } from './useResponsiveProps.js';

const getCurrentBreakpoint = (mobileQuery, tabletQuery)=>{
    if (mobileQuery.matches) {
        return "mobile";
    }
    if (tabletQuery.matches) {
        return "tablet";
    }
    return "desktop";
};
const BreakpointContext = createContext(null);
/**
 * Provide Breakpoint listener context. Allows programatically resolving the
 * current media breakpoint value.
 */ const BreakpointProvider = ({ children  })=>{
    const [state, setState] = useState(null);
    useEffect(()=>{
        let mounted = true;
        const mobileQuery = window.matchMedia(`(max-width: ${getResponsiveSizePX("mobile")}px)`);
        const tabletQuery = window.matchMedia(`(max-width: ${getResponsiveSizePX("tablet")}px)`);
        const onChange = ()=>{
            if (!mounted) {
                return;
            }
            const newBreakPoint = getCurrentBreakpoint(mobileQuery, tabletQuery);
            if (newBreakPoint !== state) {
                setState(newBreakPoint);
            }
        };
        tabletQuery.addListener(onChange);
        mobileQuery.addListener(onChange);
        onChange();
        return ()=>{
            mounted = false;
            tabletQuery.removeListener(onChange);
            mobileQuery.removeListener(onChange);
        };
    }, [
        state
    ]);
    return React__default.createElement(BreakpointContext.Provider, {
        value: state
    }, children);
};
/**
 * Retrieve the current breakpoint value.
 */ const useBreakpoint = ()=>useContext(BreakpointContext);

export { BreakpointContext, BreakpointProvider, useBreakpoint };
